import { Skeleton } from 'antd';
import { Display } from '@/components/Display/Display';
import { fileStatusDic } from '@/utils/Page/constant';
import PreviewImg from '@/components/Web/PreviewImg';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import s from './style.module.scss';

const WebImgage = ({ file, preview, canClickImage, from }, ref) => {
    const imgRef = useRef(null);
    const openImg = () => {
        imgRef.current?.setVisible(true);
    };
    useImperativeHandle(ref, () => {
        return {
            openImg
        };
    });
    return (
        <>
            <Display show={file.status === fileStatusDic.ing}>
                <Skeleton.Node style={{ width: 48, height: 48 }} active />
            </Display>
            <Display show={file.status !== fileStatusDic.ing}>
                <PreviewImg
                    ref={imgRef}
                    canClickImage={canClickImage}
                    width={48}
                    height={48}
                    errClassName={s['err-img-wrap']}
                    src={file?.file_url}
                    style={{ borderRadius: 8, width: 48, height: 48, objectFit: 'cover', cursor: from === 'send' ? 'initial' : 'pointer' }}
                    preview={preview === undefined ? file?.file_url : preview}
                />
            </Display>
        </>
    );
};
export default forwardRef(WebImgage);
